import moment from "moment";

export function startOfWeek(date) {
  const daySelected = moment(date);
  const from_date = daySelected.startOf("week");

  return moment(from_date);
}



// WEBPACK FOOTER //
// src/modules/presence/expenseReports/ExpenseReports.utils.js